<template>
  <div class="block-questions">
    <h1 v-if="title" class="title">{{ title }}</h1>
    <question v-for="(question, index) in items"
          :key="question.index"
          :number="index + 1"
          :title="question.title"
          :reverse="question.reverse"
          :value="form[question.field]"
          :field='question.field'
          @input='rangeChange' />

    <div v-if="prev || next" class="box-full-footer">
      <v-button v-if="prev" :to="prev" super-dark arrow-left>
        Voltar
      </v-button>
      <v-button v-if="next" :to="next" super-dark arrow>
        Avançar
      </v-button>
    </div>
  </div>
</template>

<script>
  import Question from './Question';
  import questionsVuex from '../mixins/questionsVuexTeste';
  import vButton from '../vButton';

  export default {
    name: 'questions',
    mixins: [questionsVuex],
    components: { Question, vButton },
    props: {
      title: String,
      items: Array,
      keyForm: String,
      prev: String,
      next: String,
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 48px;
    text-transform: uppercase;
    letter-spacing: 8px;
    @media (max-width: 576px) {
      margin-top: 120px;
    }
  }
  .box-full-footer {
    width: 60%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 991px) {
      width: 100%;
    }
    @media (max-width: 480px) {
      /deep/ .button {
        padding: 32px 24px !important;
        margin-bottom: 24px;
      }
    }
    @media (max-width: 370px) {
      /deep/ .button {
        padding: 32px 12px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/test/Questions.vue